import { Option, makeOpt, emptyOpt } from "../../../custom_utils/option"

export const trackNewsletter = () =>
  DataLayer.push({
    category: "Newsletter",
    action: "Footer click",
    label: window.location.pathname,
  })

  export const trackMembershipFromFooter = () =>
  DataLayer.push({
    category: "Membership",
    action: "Footer click",
    label: window.location.pathname,
  })

  export const trackMembershipFromLocationDetail = () =>
  DataLayer.push({
    category: "Membership",
    action: "Click trigger on Location Detail Page",
    label: window.location.pathname,
  })

export const trackSocial = (platform: string) =>
  DataLayer.push({
    category: "Socials",
    action: platform,
    label: window.location.pathname,
  })

export const trackContact = (type: "telephone" | "email") =>
  DataLayer.push({
    category: "Contact",
    action: type,
    label: window.location.pathname,
  })

export const trackLogin = () =>
  DataLayer.push({
    category: "Login",
    action: "Click",
    label: window.location.pathname,
  })

export const trackJumboButton = (label: string) =>
  DataLayer.push({
    category: "Header button",
    action: label,
    label: window.location.pathname,
  })

export const trackActivityClick = (activityTitle: string, clusterTitle: string) =>
  DataLayer.push({
    category: "Activities",
    action: clusterTitle,
    label: activityTitle,
  })

export const trackActivitySubscribe = (date: string, start: string, end: string) =>
  DataLayer.push({
    category: "Activity subscribe",
    action: `${date} > ${start} - ${end}`,
    label: window.location.pathname,
  })

export const trackActivitySelection = (type: "where" | "when", label: string) =>
  DataLayer.push({
    category: "Activities filter",
    action: type,
    label: label,
  })

export const trackCollectionSearch = (query: string) =>
  DataLayer.push({
    category: "Collection search",
    action: query,
    label: window.location.pathname,
  })

export const trackCookiesAccepted = () =>
  DataLayer.push({
    event: "cookies-accepted",
  })

export const trackCookiesDenied = () =>
  DataLayer.push({
    event: "cookies-denied",
  })

export namespace DataLayer {
  interface DataLayerApi {
    push: (data: any) => void
  }

  export const getApi: () => Option<DataLayerApi> = () =>
    window["dataLayer"] ? makeOpt(window["dataLayer"]) : emptyOpt()

  export const push: (data: any) => void = data => {
    const Api = getApi()

    if (Api.kind == "some") {
      Api.value.push({
        event: "aanzet-event",
        ...data,
      })
    }
    
    if (Api.kind == "none" || !window['dataLayer']) {
      console.log("DataLayer or GTM not found, failed to push event", data)
    }
  }
}
